import React from 'react';
import LinkV2 from 'components/Link/LinkV2';
import PropTypes from 'prop-types';
// import ImageV2 from 'components_v2/common/ImageV2';
import s from './CapsuleNew.scss';

function CapsuleNew({
  item,
  isLarge,
  noStyle,
  isSmallSticky,
  ga4Type,
  ga4Category,
  prefixRequired,
  sunsignName,
  isRedStyle,
}) {
  // const ImageElement = ImageV2;
  return (
    <LinkV2
      to={item.wu}
      className={`${s.capsuleNew} ${isLarge ? s.large : ''} ${
        isRedStyle ? s.redStyle : ''
      } ${isSmallSticky ? s.smallSticky : ''} ${noStyle ? s.noStyle : ''} ${
        (sunsignName &&
          typeof sunsignName === 'string' &&
          (sunsignName.toLowerCase() === item.hl || sunsignName === item.hl)) ||
        item.isTop === 'true' ||
        item.isTop
          ? `${s.active}`
          : ''
      }`}
      id={item.hl}
      ga4Data={
        ga4Type && [
          {
            event: 'user_click',
            type: `${ga4Type}`,
            story_no: `${item.gaIndex}`,
            label: item.hl,
            category: ga4Category,
          },
        ]
      }
    >
      {prefixRequired ? `# ${item.hl}` : item.hl}
    </LinkV2>
  );
}
CapsuleNew.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  title: PropTypes.string,
  isLarge: PropTypes.string,
  noStyle: PropTypes.string,
  ga4Category: PropTypes.string,
  ga4Type: PropTypes.string,
  prefixRequired: PropTypes.bool,
};

CapsuleNew.defaultProps = {
  title: '',
  isLarge: '',
  noStyle: '',
  ga4Category: '',
  ga4Type: '',
  prefixRequired: true,
};

export default CapsuleNew;
